/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.VoidACHTransactionResponse | undefined,
  (requestParams: vp.VoidACHTransactionRequest) => void,
  () => void,
];

function usePostVoidACHTransaction({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.VoidACHTransactionRequest>();
  const [response, setResponse] = useState<vp.VoidACHTransactionResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.VoidACHTransactionRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postVoidACHTransaction(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.VoidACHTransactionRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostVoidACHTransaction);
